import TrainingSkill from '../skill';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSkill.store(({ trainingId, skillId }, fetch) => {
    // Prepare request
    let formData = new FormData();
    formData.append('skill_id', skillId);

    return fetch.post(`/trainings/${trainingId}/skills`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
